import React from 'react';
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { RepresentantesComponent } from '../../Components/Historico/RepresentantesComponent';
import { Footer } from '../../Components/Footer/FooterComponent';

export const RepresentantesActuales = (props) => {
    const maxYear = Math.max(...props.Data.map(representante => representante.year));
    const representantesActuales = props.Data.filter(representante => representante.year === maxYear);

    return (
        <>
        <LogoHeader I18n={props.I18n} />
        <NavDesktop I18n={props.I18n}/>
        <NavMobile I18n={props.I18n}/>
        <h1 className='titulo-page'>{props.I18n.OurRepresentantes}</h1>
        <RepresentantesComponent Data={representantesActuales} I18n={props.I18n}  />
        <Footer I18n={props.I18n} />
        </>
    );
}
